import $ from 'jquery';

export default () => {
	const $buttons = $('.button');

	$buttons.click(function () {
		const $button = $(this);

		$button.addClass('button_animate');
		$button.blur();
		setTimeout(() => {
			$button.removeClass('button_animate');
		}, 600);
	});
};



// WEBPACK FOOTER //
// ./app/blocks/button/index.js